import { ConsultAgreeItem, ConsultAgreeListItemDescription } from '@/types';

const CONSULT_AGREE_PRIVACY: ConsultAgreeListItemDescription[] = [
  {
    text: `[개인정보 수집 및 이용 동의]

    상담 예약 서비스 제공을 위해 아래와 같이 개인정보를 수집·이용 하고자합니다.
    내용을 자세히 읽으신 후 동의해주시기 바랍니다.
    이용자가 동의한 내용 외의 다른 목적으로 사용하지 않으며, 이용자는 동의를 거부할 권리가 있습니다.
    단, 동의 거부 시 상담신청 서비스를 받으실 수 없습니다.
    그 밖의 사항은 (주)한샘 개인정보처리방침에 따릅니다.
    
    1. 개인정보 수집 및 이용 목적
    · 상담 서비스 이행(상담 신청, 해피콜, 상담 매장 및 영업사원 배정)
    · 제품 상담 및 견적 서비스 제공
    · 제품 설치
    · 고객 상담 서비스 제공
    · 이벤트 참여 안내 및 당첨자 연락, 사은품 배송, 본인 확인

    2. 수집 항목
    · 이름, 휴대폰 번호, 주소
    · 상담에 필요한 현장 공사 정보
    \n`,
    isBold: false,
  },
  {
    text: `3. 보유 및 이용기간
    · 회원: 회원 탈퇴 시 까지
    · 비회원: 서비스 종료 후 1년`,
    isBold: true,
  },
];

const CONSULT_AGREE_PROVIDE: ConsultAgreeListItemDescription[] = [
  {
    text: `[개인정보 제3자 제공 동의]

    상담 예약 서비스 제공을 위해 아래와 같이 개인정보를 제3자에게 제공 하고자 합니다.
    내용을 자세히 읽으신 후 동의해주시기 바랍니다.
    이용자가 동의한 내용 외의 다른 목적으로 사용하지 않으며, 이용자는 동의를 거부할 권리가 있습니다.
    단, 동의 거부 시 상담신청 서비스를 받으실 수 없습니다.
    그 밖의 사항은 (주)한샘 개인정보처리방침에 따릅니다.
    \n`,
    isBold: false,
  },
  {
    text: `1. 제공 받는 자 : 한샘대리점, 한샘제휴점
    
    2. 제공목적
    · 상담 서비스 이행, 제품 상담 및 견적 서비스 제공
    · 제품 설치
    · 고객 상담 서비스 제공
    \n`,
    isBold: true,
  },
  {
    text: `3. 제공항목
    · 이름, 휴대폰 번호, 주소
    · 상담에 필요한 현장 공사 정보
    \n`,
    isBold: false,
  },
  {
    text: `4. 보유 및 이용기간
    · 회원: 회원 탈퇴 시 까지
    · 비회원: 서비스 종료 후 1년`,
    isBold: true,
  },
];

export const CHANNEL_TYPE_TEXTS = [
  { type: 'OPKG_01', text: '통합메인 퀵버튼' },
  { type: 'OPKG_02', text: '햄버거' },
  { type: 'OPKG_03', text: '리모델링섹션메인' },
  { type: 'OPKG_04', text: '언택트 -> 상담신청' },
  { type: 'OPKG_05', text: '푸터' },
  { type: 'OP02_01', text: '홈아이디어 상세' },
  { type: 'OP04_01', text: '매장/리하우스대리점' },
  { type: 'OP04_02', text: '매장/디자인파크/리모델링' },
  { type: 'OP07_01', text: '예산 감잡기' },
  { type: 'OP08_01', text: '상품/리모델링상품' },
  { type: 'OP08_02', text: '스토어상품/리모델링상품' },
  { type: 'OP09_01', text: '이벤트/리모델링이벤트' },
  { type: 'OP10_01', text: '인테리어 취향테스트' },
  { type: 'OP11_01', text: '플로팅_리모델링섹션' },
  { type: 'OP11_02', text: '플로팅_홈아이디어' },
];

export const CONSULT_AGREE_LIST: ConsultAgreeItem[] = [
  {
    id: 1,
    title: '개인정보 수집 및 이용동의',
    description: CONSULT_AGREE_PRIVACY,
    name: 'agreement.privacy',
    checked: false,
  },
  {
    id: 2,
    title: '개인정보 제3자 제공 동의',
    description: CONSULT_AGREE_PROVIDE,
    name: 'agreement.provide',
    checked: false,
  },
];

const UNTACT_CONSULT_AGREE_PRIVACY: ConsultAgreeListItemDescription[] = [
  {
    text: `[개인정보 수집 및 이용 동의]

    상담 예약 서비스 제공을 위해 아래와 같이 개인정보를 수집·이용 하고자합니다.
    내용을 자세히 읽으신 후 동의해주시기 바랍니다.
    이용자가 동의한 내용 외의 다른 목적으로 사용하지 않으며, 이용자는 동의를 거부할 권리가 있습니다.
    단, 동의 거부 시 상담신청 서비스를 받으실 수 없습니다.
    그 밖의 사항은 (주)한샘 개인정보처리방침에 따릅니다.
    
    1. 개인정보 수집 및 이용 목적
    · 상담 서비스 이행(상담 신청, 해피콜, 상담 매장 및 영업사원 배정)
    · 제품 상담 및 견적 서비스 제공
    · 제품 설치
    · 고객 상담 서비스 제공
    · 이벤트 참여 안내 및 당첨자 연락, 사은품 배송, 본인 확인

    2. 수집 항목
    · 이름, 휴대폰 번호, 주소
    · 상담에 필요한 현장 공사 정보
    \n`,
    isBold: false,
  },
  {
    text: `3. 보유 및 이용기간
    · 회원 탈퇴 시 까지`,
    isBold: true,
  },
];

const UNTACT_CONSULT_AGREE_PROVIDE: ConsultAgreeListItemDescription[] = [
  {
    text: `[개인정보 제3자 제공 동의]

    상담 예약 서비스 제공을 위해 아래와 같이 개인정보를 제3자에게 제공 하고자 합니다.
    내용을 자세히 읽으신 후 동의해주시기 바랍니다.
    이용자가 동의한 내용 외의 다른 목적으로 사용하지 않으며, 이용자는 동의를 거부할 권리가 있습니다.
    단, 동의 거부 시 상담신청 서비스를 받으실 수 없습니다.
    그 밖의 사항은 (주)한샘 개인정보처리방침에 따릅니다.
    \n`,
    isBold: false,
  },
  {
    text: `1. 제공 받는 자 : 한샘대리점, 한샘제휴점
    
    2. 제공목적
    · 상담 서비스 이행, 제품 상담 및 견적 서비스 제공
    · 제품 설치
    · 고객 상담 서비스 제공
    \n`,
    isBold: true,
  },
  {
    text: `3. 제공항목
    · 이름, 휴대폰 번호, 주소
    · 상담에 필요한 현장 공사 정보
    \n`,
    isBold: false,
  },
  {
    text: `4. 보유 및 이용기간
    · 회원 탈퇴 시 까지`,
    isBold: true,
  },
];

export const UNTACT_CONSULT_AGREE_LIST: ConsultAgreeItem[] = [
  {
    id: 1,
    title: '개인정보 수집 및 이용동의',
    description: UNTACT_CONSULT_AGREE_PRIVACY,
    name: 'agreement.privacy',
    checked: false,
  },
  {
    id: 2,
    title: '개인정보 제3자 제공 동의',
    description: UNTACT_CONSULT_AGREE_PROVIDE,
    name: 'agreement.provide',
    checked: false,
  },
];
